"use client";

import { ArrowRight, Ban, Hotel, Lock, ShieldCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurGuarantee() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const grid = useRevealOnScroll<HTMLDivElement>();
  const cta = useRevealOnScroll<HTMLDivElement>();
  const policies = [{
    icon: Ban,
    title: "Καμία Πώληση Δεδομένων",
    description: "Δεσμευόμαστε ρητά ότι δεν πουλάμε ούτε ενοικιάζουμε τα προσωπικά σας δεδομένα σε τρίτες διαφημιστικές εταιρείες.",
    label: "Απόλυτη Ιδιωτικότητα"
  }, {
    icon: Hotel,
    title: "Κοινοποίηση σε Ξενοδοχεία",
    description: "Μοιραζόμαστε με το κατάλυμα μόνο τα απαραίτητα στοιχεία που απαιτούνται για την ολοκλήρωση της κράτησής σας.",
    label: "Μόνο για την Κράτηση"
  }, {
    icon: Lock,
    title: "Περιορισμένη Πρόσβαση",
    description: "Η πρόσβαση στα στοιχεία σας περιορίζεται αποκλειστικά στο εξουσιοδοτημένο προσωπικό που διαχειρίζεται το αίτημά σας.",
    label: "Ελεγχόμενη Ροή"
  }, {
    icon: ShieldCheck,
    title: "Ασφαλής Μεταφορά",
    description: "Κάθε ανταλλαγή πληροφοριών με τους συνεργάτες μας πραγματοποιείται μέσω κρυπτογραφημένων καναλιών υψηλής ασφάλειας.",
    label: "Πρωτόκολλο SSL"
  }];
  return <section data-section-id="673" id="κοινοποίηση-δεδομένων" className="relative overflow-hidden bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="relative mx-auto max-w-7xl">
        {}
        <div ref={header.ref} className={`max-w-3xl transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="text-sm font-bold tracking-widest text-primary uppercase font-sans">
            Διαφάνεια & Εμπιστοσύνη
          </p>
          <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground font-sans tracking-tighter uppercase">
            Πώς Διαχειριζόμαστε τα Δεδομένα σας
          </h2>
          <p className="mt-6 text-lg text-muted-foreground max-w-2xl font-sans leading-relaxed">
            Η HotelDeals.gr λειτουργεί ως πύλη απευθείας κρατήσεων. Η προστασία της ιδιωτικότητάς σας είναι η προτεραιότητά μας, γι' αυτό και η κοινοποίηση πληροφοριών γίνεται μόνο όταν είναι απολύτως απαραίτητο.
          </p>
        </div>

        {}
        <div ref={grid.ref} className={`mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border transition-all duration-700 ease-out ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {policies.map((policy, i) => {
          const Icon = policy.icon;
          return <Card key={i} data-index={i} className="bg-background border-none p-8 flex flex-col h-full hover:bg-accent/5 transition-colors duration-300">
                <div className="mb-6">
                  <Icon className="w-10 h-10 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-bold text-foreground font-sans mb-3 uppercase tracking-tight">
                  {policy.title}
                </h3>
                <p className="text-sm text-muted-foreground font-sans leading-relaxed mb-8 flex-1">
                  {policy.description}
                </p>
                <Badge variant="outline" className="border-primary text-primary font-bold uppercase text-[10px] px-3 py-1">
                  {policy.label}
                </Badge>
              </Card>;
        })}
        </div>

        {}
        <div ref={cta.ref} className={`mt-16 flex flex-col sm:flex-row items-center justify-between gap-8 border-t border-border pt-12 transition-all duration-700 ease-out ${cta.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="max-w-xl">
            <h4 className="text-2xl font-bold font-sans tracking-tight uppercase">
              Χωρίς κρυφές χρεώσεις. <span className="text-primary">Χωρίς εμπορία δεδομένων.</span>
            </h4>
            <p className="mt-2 text-muted-foreground font-sans">
              Εστιάζουμε αποκλειστικά στο να σας βρούμε την καλύτερη τιμή απευθείας από το ξενοδοχείο.
            </p>
          </div>
          <Button asChild variant="default" size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold text-base px-8 h-14 uppercase tracking-wider">
            <Link to="/HowItWorksPage">
              Μάθετε Περισσότερα
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}